export default "__VITE_ASSET__BPaTdLtt__"